/**
 * StatusCurrentToggle.tsx
 * ----------------
 * Toggles a list of current incidents.
 */
import { IconButton } from '@fluentui/react/lib/Button';
import * as React from 'react';

import { FluentSvgIcon } from '../shared/FluentSvgIcon';
import { StatusCurrentList, StatusCurrentListProps } from './StatusCurrentList';

/**
 * Use a toggle to hide/show the contents of the current incidents
 * @param props
 */
export function StatusCurrentToggle (props: StatusCurrentListProps) {
    // Component state hooks
    const [isExpanded, setIsExpanded] = React.useState<boolean>(false);

    // Callback hooks
    const onIsExpandedClicked = React.useCallback(() => {
        setIsExpanded(!isExpanded);

        // Removed automatic focus on content for accessibility bug 1566125, reported July 4th 2022.
    }, [isExpanded, setIsExpanded]);

    const caretIconName = isExpanded ? 'ChevronUpMed' : 'ChevronDownMed';
    const caretTitle = isExpanded ? 'Hide current incidents' : 'Show current incidents';

    // Details node needs to exist to have focus when isExpanded is clicked, which is why we use visibility instead of
    // conditional rendering.
    const detailsProps = isExpanded ? {} : { style: { display: 'none' as 'none' } };

    const toggleRowStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: isExpanded ? 20 : 0,
    };

    return (
        <>
            <div style={toggleRowStyle} className="string-header">
                Current Incidents
                {/* Spacer to grow and take up the room in the middle */}
                <div style={{ flexGrow: 1 }}></div>
                <IconButton
                    ariaLabel={caretTitle}
                    iconProps={{ iconName: caretIconName }}
                    onClick={onIsExpandedClicked}
                    onRenderIcon={props => {
                        const iconName = props !== undefined && props.iconProps !== undefined
                            ? props.iconProps.iconName
                            : undefined;
                        //TODO to update the class names here to align with the component they're a part of
                        const className = iconName === 'ChevronDownUp'
                            ? 'status-recent-updates-row__caret-icon status-recent-updates-row__caret-icon--expanded'
                            : 'status-recent-updates-row__caret-icon';

                        return (
                            <FluentSvgIcon
                                className={className}
                                iconName={iconName !== undefined ? iconName : ''} />
                        );
                    }}
                    title={caretTitle} />
            </div>

            <div {...detailsProps}>
                <StatusCurrentList {...props} useHeader={false} />
            </div>
        </>
    );
}
